
  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "h3fml3hc",
  };

  function loadIntercom() {
    if (window.IntercomLoaded) return;
    window.IntercomLoaded = true;

    (function () {
      var w = window;
      var ic = w.Intercom;

      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () { i.c(arguments); };
        i.q = [];
        i.c = function (args) { i.q.push(args); };
        w.Intercom = i;

        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true; // stays async
          s.src = 'https://widget.intercom.io/widget/h3fml3hc';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };

        l(); // only called when we decide to load Intercom
      }
    })();
  }
window.addEventListener('load', function () {
  setTimeout(loadIntercom, 3000); // 8–10s to get out of Lighthouse's main window
});

  // Your Klaviyo code can stay as-is:
  var _learnq = _learnq || [];

  document.addEventListener('DOMContentLoaded', function () {
    var classname = document.getElementsByClassName("product-form__submit");
    var addToCart = function () {
  
    };
    for (var i = 0; i < classname.length; i++) {
      classname[i].addEventListener('click', addToCart, false);
    }
  });

